import React from "react";
import {
  dateTimeFieldToDate,
  formatRP,
} from "../../../Utils/externalFunctions";
import { getStatusData, STATUS_DATA_TYPE } from "../../../Constant/StatusData";
import { getStatusBadge } from "../../../Utils/otherFunctions";
import { H5, P } from "../../../AbstractElements";
import { Table } from "reactstrap";

const RenderContentMail = ({ mail, module }) => {
  if (!mail) return null;

  const TransactionDetails = (keterangan, type) => {
    const statusData = getStatusData(keterangan, type);
    return getStatusBadge(statusData);
  };

  const transaksi = (mail) => (
    <div className="emailread-group">
      <div className="read-group">
        <P>{new Date(mail.timestamp_edit_terakhir).toLocaleString()}</P>
        <P>Oleh {mail.diajukan_oleh}</P>
      </div>
      <div className="read-group">
        <H5>Transaksi</H5>
      </div>
      <Table>
        <tbody>
          <tr>
            <td>
              <P>
                <strong>ID Transaksi</strong>
              </P>
            </td>
            <td>
              <P>: {mail.id_transaksi}</P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>Unit kerja</strong>
              </P>
            </td>
            <td>
              <P>: {mail.id_unit_kerja}</P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>Nilai Transaksi</strong>
              </P>
            </td>
            <td>
              <P>: Rp{formatRP(mail.nilai_transaksi)}</P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>Tanggal Diajukan</strong>
              </P>
            </td>
            <td>
              <P>: {new Date(mail.tanggal_diajukan).toLocaleDateString()}</P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>Tanggal Transaksi</strong>
              </P>
            </td>
            <td>
              <P>: {new Date(mail.tanggal_transaksi).toLocaleDateString()}</P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>Keterangan:</strong>
              </P>
            </td>
            <td>
              <P>: {mail.keterangan}</P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>Status Transaksi:</strong>
              </P>
            </td>
            <td>
              <P>
                :{" "}
                {TransactionDetails(
                  mail.id_status_transaksi,
                  STATUS_DATA_TYPE.Transaksi
                )}
              </P>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );

  const realokasi = (mail) => (
    <div className="emailread-group">
      <div className="read-group">
        <P>Oleh {mail.diajukan_oleh}</P>
      </div>
      <div className="read-group">
        <H5>Realokasi</H5>
      </div>
      <Table>
        <tbody>
          <tr>
            <td>
              <P>
                <strong>DPSJ</strong>
              </P>
            </td>
            <td>
              <P>: {mail.unit_kerja}</P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>Kegiatan</strong>
              </P>
            </td>
            <td>
              <P>
                : {mail.kd_keg} - {mail.nm_keg}
              </P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>Akun</strong>
              </P>
            </td>
            <td>
              <P>
                : {mail.kd_akun} - {mail.nm_akun}
              </P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>Diajukan Oleh</strong>
              </P>
            </td>
            <td>
              <P>: {mail.diajukan_oleh}</P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>Nilai Anggaran</strong>
              </P>
            </td>
            <td>
              <P>: Rp{formatRP(mail.nilai_anggaran)}</P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>Tanggal Diajukan</strong>
              </P>
            </td>
            <td>
              <P>: {dateTimeFieldToDate(mail.waktu_pengajuan)}</P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>Keterangan</strong>
              </P>
            </td>
            <td>
              <P>: {mail.keterangan}</P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>Status Transaksi</strong>
              </P>
            </td>
            <td>
              <P>
                :{" "}
                {TransactionDetails(
                  mail.id_status_realokasi,
                  STATUS_DATA_TYPE.Realokasi
                )}
              </P>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );

  const UMK = (mail) => (
    <div className="emailread-group">
      <div className="read-group">
        <P>{new Date(mail.date_created).toLocaleString()}</P>
        <P>Oleh {mail.diajukan_oleh}</P>
      </div>
      <div className="read-group">
        <H5>UMK</H5>
      </div>
      <Table>
        <tbody>
          <tr>
            <td>
              <P>
                <strong>ID UMK</strong>
              </P>
            </td>
            <td>
              <P>: {mail.id_umk}</P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>DPSJ</strong>
              </P>
            </td>
            <td>
              <P>: {mail.id_unit_kerja}</P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>Nilai Anggaran</strong>
              </P>
            </td>
            <td>
              <P>: Rp{formatRP(mail.nilai)}</P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>Tanggal mulai</strong>
              </P>
            </td>
            <td>
              <P>: {mail.tanggal_mulai}</P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>Tanggal selesai</strong>
              </P>
            </td>
            <td>
              <P>: {mail.tanggal_selesai}</P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>Keterangan</strong>
              </P>
            </td>
            <td>
              <P>: {mail.keterangan}</P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>Status Transaksi</strong>
              </P>
            </td>
            <td>
              <P>
                : {TransactionDetails(mail.id_status_umk, STATUS_DATA_TYPE.UMK)}
              </P>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );

  const UMO = (mail) => (
    <div className="emailread-group">
      <div className="read-group">
        <P>{new Date(mail.date_modified).toLocaleString()}</P>
        <P>Oleh {mail.diajukan_oleh}</P>
      </div>
      <div className="read-group">
        <H5>UMO</H5>
      </div>
      <Table>
        <tbody>
          <tr>
            <td>
              <P>
                <strong>Kode UMO</strong>
              </P>
            </td>
            <td>
              <P>: {mail.kode_umo}</P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>DPSJ</strong>
              </P>
            </td>
            <td>
              <P>: {mail.id_unit_kerja}</P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>Nilai Anggaran</strong>
              </P>
            </td>
            <td>
              <P>: Rp{formatRP(mail.nilai)}</P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>Untuk Tanggal</strong>
              </P>
            </td>
            <td>
              <P>: {mail.untuk_tanggal}</P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>Batas Akhir</strong>
              </P>
            </td>
            <td>
              <P>: {mail.batas_akhir}</P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>Keperluan</strong>
              </P>
            </td>
            <td>
              <P>: {mail.keterangan}</P>
            </td>
          </tr>
          <tr>
            <td>
              <P>
                <strong>Status Transaksi</strong>
              </P>
            </td>
            <td>
              <P>
                : {TransactionDetails(mail.id_status_umo, STATUS_DATA_TYPE.UMO)}
              </P>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );

  switch (module) {
    case "Transaksi":
      return transaksi(mail);
    case "Realokasi":
      return realokasi(mail);
    case "UMK":
      return UMK(mail);
    case "UMO":
      return UMO(mail);
    default:
      return <P>Unknown module</P>;
  }
};

export default RenderContentMail;
